export default __webpack_public_path__ + "static/media/mShoes_1_p2.49808d3b.jpeg";